/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ProcessTypeDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    processTypeIdentifier: ProcessTypeDto.processTypeIdentifier;
    nameDe: string;
    nameEn: string;
    active?: boolean;
};
export namespace ProcessTypeDto {
    export enum processTypeIdentifier {
        INITIAL_APPROVAL = 'INITIAL_APPROVAL',
        RENEWAL = 'RENEWAL',
        RENEWAL_APPROVAL = 'RENEWAL_APPROVAL',
        CHANGE_APPROVAL = 'CHANGE_APPROVAL',
        ADDITIONAL_FORMULATIONS = 'ADDITIONAL_FORMULATIONS',
        ADDITIONAL_SHEET = 'ADDITIONAL_SHEET',
        FORMULATION_CHANGE = 'FORMULATION_CHANGE',
        LEGACY_MIGRATION = 'LEGACY_MIGRATION',
    }
}

